// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"Mobile_contentSection__25iNU","customContainer":"Mobile_customContainer__31BuZ"};